<template>
	<!--todo: put this into a 'header' component-->
	<v-app>
		<v-layout>
			<v-app-bar :elevation="1" density="compact">
				<template v-slot:prepend>
					<MutualLogo />
				</template>

				<v-app-bar-title class="text-start">{{ routeTitle }}</v-app-bar-title>

				<NotificationIcon />

				<m-btn icon="mdi-cog" @click="showSettings" variant="text"></m-btn>
				<m-btn variant="text">
					<template v-slot:prepend>
						<ProfilePicture />
					</template>
					<template v-slot:append>
						{{ authStore.getName }}
					</template>

					<v-menu offset-y activator="parent">
						<!-- Menu content -->
						<v-list>
							<v-list-item button @click="logout">
								<v-list-item-title>Log out</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</m-btn>
			</v-app-bar>
			<v-navigation-drawer permanent v-model="drawer" :rail="rail" elevation="5" @click="rail = !rail" width="320" >

				<!-- NOTE: The SSAM (System Support and Maintenance) section is intentionally excluded from
					this sidebar. It is accessed via the user profile menu and must never be added here. -->
				<v-list density="compact" class="mt-3" nav>
					<v-list-item class="text-start" value="Underwriter Workbench" href="/workbench" prepend-icon="mdi-tools"
						title="Underwriter Workbench">
					</v-list-item>

					<v-list-item class="text-start" value="Batch Dashboard" href="/batch-dashboard" prepend-icon="mdi-play-box-multiple"
						title="Batch Dashboard">
					</v-list-item>

					<v-list-item class="text-start" value="Policy Form Trackers" href="/policy-form-trackers" prepend-icon="mdi-file-document-multiple"
						title="Policy Form Trackers">
					</v-list-item>

					<!-- 2025.06.22 - BSU
					This will come back into play when the policy is kept in context between pages-->
					<!-- <v-list-item class="text-start" value="Fix My Policy" href="/policy-fix" prepend-icon="mdi-auto-fix"
						title="Fix My Policy">
					</v-list-item> -->

				</v-list>

				<template v-slot:append>
					<v-container fluid>
						<v-row justify="end" v-if="!rail">
							<v-btn icon="mdi-chevron-left" variant="text" @click.stop="rail = !rail"></v-btn>
						</v-row>

						<v-row justify="center">
							<v-btn icon="mdi-chevron-right" variant="text" @click.stop="rail = !rail" v-if="rail"></v-btn>
						</v-row>
					</v-container>
				</template>
			</v-navigation-drawer>
			<v-main id="main-content" class="d-flex justify-center flex-wrap ma-0">
				<router-view />
				<SpeedNav />
				<AppSettings :isActive="settingsOn" @closed="settingsClosed" />
				<NotificationBar />
			</v-main>
		</v-layout>
	</v-app>
</template>
<script lang="ts">

import { useRoute } from 'vue-router';
import { ref, watchEffect, onMounted, inject } from 'vue';
import { AuthService } from '@/contracts/AuthService';
import { useAuthStore } from '@/stores/auth.store';
import { AppNotification } from './models/NotificationModels';
import AppSettings from '@/components/AppSettings.vue';
import MutualLogo from '@/components/MutualLogo.vue';
import NotificationIcon from '@/components/NotificationIcon.vue';
import NotificationBar from '@/components/NotificationBar.vue';
import MBtn from '@/components/BaseButton.vue';
import ProfilePicture from './components/ProfilePicture.vue';
import SpeedNav from './components/SpeedNav.vue';

export default {
	name: 'App',
	components: {
		AppSettings,
		MutualLogo,
		NotificationIcon,
		NotificationBar,
		MBtn,
		ProfilePicture,
		SpeedNav
	},
	setup() {
		const route = useRoute();
		const routeTitle = ref<string>('');
		const auth = inject<AuthService>('auth');
		const settingsOn = ref<boolean>(false);
		const drawer = ref<boolean>(true);
		const rail = ref<boolean>(true); // Used for the navigation drawer rail mode

		const authStore = useAuthStore();

		const messages = ref<number>(0);

		const showSettings = () => {
			settingsOn.value = true;
		}

		const showNotifications = ref<boolean>(false);

		const settingsClosed = () => {
			settingsOn.value = false;
		}

		const markAsRead = (notification: AppNotification) => {
            notification.read = true;
            // Optionally, emit an event or update the notifications array
        };

		watchEffect(() => {
			routeTitle.value = String(route.meta.title);
		});

		onMounted(async () => {
			//any logic in here?
			//console.log('mounted', authStore.getName);
		});

		return {
			drawer,
			rail,
			authStore,
			messages,
			settingsOn,
			routeTitle,
			showNotifications,
			showSettings,
			markAsRead,
			settingsClosed,
			logout: async () => {
				if (auth) {
					auth.logout();
				}
			}
		}
	}
}
</script>

<style>
#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
}

</style>
